// extracted by mini-css-extract-plugin
export default {"successColor":"OpportunityTable_successColor__l9pFN","unlistedColor":"OpportunityTable_unlistedColor__P3Fv8","breakWord":"OpportunityTable_breakWord__igdDe"};